<footer class="footer">
  <div class="footer__inner">

    <!-- Top: Logo + Nav (space-between) -->
    <div class="footer__nav-block">
      <div class="footer__logo" (click)="scrollTo('hero')" role="button" tabindex="0" aria-label="Ir al inicio">
        <span class="footer__logo-name">Aruma</span>
        <span class="footer__logo-sub">turismo</span>
      </div>

      <nav class="footer__nav" aria-label="Navegación pie de página">
        @for (link of navLinks; track link.label) {
          <button class="footer__nav-link" (click)="scrollTo(link.id)">{{ link.label }}</button>
        }
      </nav>
    </div>

    <!-- Divider -->
    <hr class="footer__divider">

    <!-- Bottom: Contact | Social | Legal -->
    <div class="footer__links-block">

      <div class="footer__col">
        <span class="footer__col-label body-s">Contacto</span>
        <div class="footer__col-links">
          <a href="https://instagram.com/arumaturismo" target="_blank" rel="noopener" class="footer__link body-xs">Instagram</a>
          <a href="mailto:arumaturismo@gmail.com" class="footer__link body-xs">arumaturismo&#64;gmail.com</a>
        </div>
      </div>

      <div class="footer__col footer__col--bordered">
        <span class="footer__col-label body-s">Redes sociales</span>
        <div class="footer__col-links">
          <a href="https://instagram.com/arumaturismo" target="_blank" rel="noopener" class="footer__link body-xs">Instagram</a>
          <a href="https://tiktok.com/@arumaturismo" target="_blank" rel="noopener" class="footer__link body-xs">Tiktok</a>
        </div>
      </div>

      <div class="footer__col">
        <span class="footer__col-label body-s">Legal</span>
        <div class="footer__col-links">
          <a href="#" class="footer__link body-xs">Aviso Legal</a>
          <a href="#" class="footer__link body-xs">Privacidad</a>
          <a href="#" class="footer__link body-xs">Cookies</a>
        </div>
      </div>

      <div class="footer__copyright">
        <span class="body-xs" style="color: var(--color-neutral-950);">Aruma Turismo {{ currentYear }} &copy;</span>
      </div>

    </div>

  </div>
</footer>
